// File to store custom components and styles for the
// react-select library.

import React from 'react';

export const customStyles = {
  multiValueLabel: base => ({
    ...base,
    whiteSpace: 'normal',
    color: '#08c',
    fontSize: '14px',
  }),
  multiValue: base => ({
    ...base,
    background: '#f2f9fc',
    border: '1px solid #c9e6f2',
    borderRadius: '2px',
    color: '#08c',
    paddingLeft: '0px',
    fontSize: '14px',
    alignItems: 'center',
  }),
  multiValueRemove: base => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
      background: 'none',
    },
  }),
};

const styles = {
  marginRight: '5px',
  marginLeft: '5px',
  '&:hover': {
    cursor: 'pointer',
  },
};

const CustomMultiValueContainer = ({
  innerProps,
  children,
  selectProps: { sortable, onLeft, onRight },
  data: { value },
}) => (
  <div className={innerProps.className}>
    {sortable && (
      <div>
        <span
          role="button"
          tabIndex={0}
          onTouchEnd={e => onLeft && onLeft(value) && e && e.preventDefault()}
          onMouseDown={e => onLeft && onLeft(value) && e && e.preventDefault()}
          onClick={() => onLeft && onLeft(value)}
          style={styles}
        >
          {'<'}
        </span>
        <span
          role="button"
          tabIndex={0}
          onTouchEnd={e => onRight && onRight(value) && e && e.preventDefault()}
          onMouseDown={e =>
            onRight && onRight(value) && e && e.preventDefault()
          }
          onClick={() => onRight && onRight(value)}
          style={styles}
        >
          {'>'}
        </span>
      </div>
    )}
    {children}
  </div>
);

export const customComponents = {
  MultiValueContainer: props => <CustomMultiValueContainer {...props} />,
};



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/customSelectOptions.js